<template>
  <div>
    <callout
      ref="callout"
      class="w-100 mb-3 mt-3"
      :has-border="true"
      :has-toggle="false"
      border-color="green"
    >
      <validation-observer v-slot="{ handleSubmit }">
        <div class="row mb-2">
          <div class="col-md-6 pl-0">
            <section-title
              class="mb-1 pl-1 no-tag-badge-parent"
              icon="fas fa-flag"
              title="Fecha de Sometido"
              title-class="font-14 "
            />
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                placeholder="DD/MM/YYYY"
                v-model="submitDate"
                custom-error-msg="La fecha de sometido es requerida."
                :error="errors[0]"
                :max-date="new Date()"
                class="ml-5"
              />
            </validation-provider>
          </div>
          <div class="col-md-6">
            <action-button
              variant="success float-right mt-4 mb-0 mr-3 "
              text="Continuar"
              i="fa fa-arrow-alt-circle-right font-18"
              class-icon="mx-0"
              @click="handleSubmit(submitReport)"
            />
            <action-button
              variant="outline-danger float-right mt-4 mb-0 mr-3 "
              i="fa fa-times-circle font-18"
              text="Cancelar"
              class-icon="mx-0 "
              @click="$emit('on-cancel')"
            />
          </div>
        </div>
      </validation-observer>
    </callout>
  </div>
</template>
<script>
import Callout from 'custom-callout'
import customDatePicker from 'custom-date-picker'
import SectionTitle from 'SectionTitle'
import ActionButton from 'ActionButton'
export default {
  name: 'SubmitForm',
  components: {
    SectionTitle,
    Callout,
    ActionButton,
    customDatePicker,
  },
  data() {
    return {
      submitDate: null,
    }
  },
  methods: {
    submitReport() {
      this.$emit('on-submit', this.submitDate)
    },
  },
}
</script>
